import { Plus } from 'lucide-react';
import EventDisplay from '../../Menus/CalendarDayMenu/EventDisplay';

/**
 * EventPanel - Component that conditionally shows event display or add event button
 * - If event exists (has eventId and not 'new'), shows EventDisplay
 * - If no event, shows button to create new event
 * Receives eventId prop
 */
export default function EventPanel({ eventData, onClose, onCreateNew, creating }) {
  const eventId = eventData?.id;
  const hasEvent = eventId && eventId !== 'new';

  if (!hasEvent) {
    // Show add event button when no event exists
    return (
      <div className="flex flex-col h-full items-center justify-center p-6">
        {creating ? (
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        ) : (
          <button
            onClick={() => onCreateNew({ ...eventData, title: 'New Event' })}
            className="flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            <Plus className="h-4 w-4" />
            Add Event
          </button>
        )}
      </div>
    );
  }

  // Show EventDisplay when event exists
  return (
    <div className="relative flex-1">
      <EventDisplay eventData={eventData} onClose={onClose} onCreateNew={onCreateNew} />
    </div>
  );
}
